export default __webpack_public_path__ + "static/media/Drama400.a98a3779.jpg";